
export class CountryNameItem {

  public noc: string;
  public short: string;
  public long: string;

  constructor(rawCountryNameItem: any) {
    this.noc = rawCountryNameItem.NOC;
    this.short = rawCountryNameItem.CShort;
    this.long = rawCountryNameItem.CName;
  }
}